import _JSXStyle from "styled-jsx/style";
import { IntersectionDetector } from '@dhis2-ui/intersection-detector';
import PropTypes from 'prop-types';
import React from 'react';
export const EndIntersectionDetector = _ref => {
  let {
    rootRef,
    onEndReached,
    dataTest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: "jsx-2799340139"
  }, /*#__PURE__*/React.createElement(IntersectionDetector, {
    rootRef: rootRef,
    onChange: _ref2 => {
      let {
        isIntersecting
      } = _ref2;
      return isIntersecting && onEndReached();
    }
  }), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2799340139"
  }, ["div.jsx-2799340139{width:100%;height:50px;position:absolute;z-index:-1;bottom:0;inset-inline-start:0;}"]));
};
EndIntersectionDetector.propTypes = {
  rootRef: PropTypes.shape({
    current: PropTypes.instanceOf(HTMLElement)
  }).isRequired,
  onEndReached: PropTypes.func.isRequired,
  dataTest: PropTypes.string
};